class smartMenu {
    constructor(config) {
        this.config = Object.assign({
            scope: '.smart-menu'
        }, config);

        this.$scope = $(this.config.scope);

        if (this.$scope.length > 0) {
            this.init();
        }
    }

    init() {
        this.addEventListeners();
    }

    addEventListeners() {
        this.$scope.on('click', this.$scope, this.toggleMenu.bind(this));
    }

    toggleMenu(event) {
        let $target = $(event.currentTarget);
        $target.toggleClass('bg-darker');
        $target.find('.menu').toggleClass('d-none');
        $target.find('.icon-logo').toggleClass('d-none');
        $target.find('.icon-white').toggleClass('d-none');
        $target.find('.close-menu').toggleClass('d-none');
    }
}

export default new smartMenu;
